import { render, staticRenderFns } from "./FeedTankReferencePoints.vue?vue&type=template&id=7824de74&scoped=true&"
import script from "./FeedTankReferencePoints.vue?vue&type=script&lang=ts&"
export * from "./FeedTankReferencePoints.vue?vue&type=script&lang=ts&"
import style0 from "./FeedTankReferencePoints.vue?vue&type=style&index=0&id=7824de74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824de74",
  null
  
)

export default component.exports